import type { LandingPageContent } from '@pages/LandingPage'

// These are the modules that don’t have a heading in them.
const NO_H1_MODULES = [
  'SpanishRiskIndicator',
  'Image',
  'FeatureTeaser',
  'StickyBanner',
]

/*
returns an array of boolean values with value as true, 
The position of at which h1 should be rendered has true as its value
*/

export const renderH1 = (content: LandingPageContent[]) => {
  let isHeadingAlreadyEnabled = false

  return content.map(module => {
    if (
      module &&
      !NO_H1_MODULES.includes(module.type) &&
      !isHeadingAlreadyEnabled
    ) {
      isHeadingAlreadyEnabled = true

      return true
    }

    return false
  })
}
